"use strict";
// Bank account type definitions — mirrors Django DRF API response shapes.
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=bank.js.map